import { useParams } from "react-router-dom";
import useShop from "@babackapp/private-api-client/client/use-shop";
import { NormalizedRole } from "./types";
import { useAuth } from "@babackapp/auth-client/context";

/**
 * Safe version of useViewerRole that handles cases where no shop is available.
 * Returns null when:
 * - No shopId in URL params
 * - Shop is loading or errored
 * - User is not found in shop
 * - User is not authenticated
 */
export default function useViewerRoleSafe(): NormalizedRole | null {
  const { shopId } = useParams<{ shopId: string }>();
  const { user } = useAuth();
  const { data: currentShop } = useShop(shopId);
  const viewerId = user?.id;

  if (!shopId) return null;

  if (!currentShop) return null;

  if (!viewerId) return null;

  // Effective membership from the backend first (BAB-3035), see useViewerRole.
  const role =
    currentShop.viewer?.roleId ??
    currentShop.users?.find((user) => user.userId === viewerId)?.roleId;

  if (!role) return null;

  return role.toLowerCase().replace(/_/g, "") as NormalizedRole;
}
